export * from './CoreModule';


// WEBPACK FOOTER //
// ./src/common/modules/core/index.ts